import React from 'react';
import ReactDOM from 'react-dom';
import TagManager from 'react-gtm-module';

import { AppProviders } from './shared/contexts';
import App from './App';

/**
|--------------------------------------------------
| App start
|--------------------------------------------------
*/
const isGoVolunteer = window?.location?.hostname?.includes('govolunteer');
const tagManagerArgs = {
  gtmId: isGoVolunteer ? 'GTM-KG9GQSJ' : 'GTM-K7C37PL',
};

TagManager.initialize(tagManagerArgs);

ReactDOM.render(
  <AppProviders>
    <App />
  </AppProviders>,
  document.getElementById('root'),
);
